import { ISettings } from '@lmnop/web-core';
import { WebsiteCoreSettings } from '@lmnop/website-core/website-core-src';


export interface IAppSettings extends ISettings {

    core: WebsiteCoreSettings;

    extensionChromeStoreUrlSpoilerProtection: string;
    extensionFirefoxStoreUrlSpoilerProtection: string;

}

